<div class="junior-container">
  <div class="banner">
   <p>Mastering Angular</p>
  </div>
    <nav class="sub-nav">
      <ul>
        <li>
          <a routerLink="/angular-framework/intro" routerLinkActive="active-link">Intro</a>
        </li>
        <li>
          <a routerLink="/angular-framework/chapters" routerLinkActive="active-link">Πρόγραμμα Σπουδών</a>
        </li>
        <li>
          <a routerLink="/angular-framework/project" routerLinkActive="active-link">Πρακτική Εφαρμογή</a>
        </li>
        <li>
          <a routerLink="/angular-framework/career" routerLinkActive="active-link">Σταδιοδρομία</a>
        </li>
        <li>
          <a routerLink="/angular-framework/prerequisites" routerLinkActive="active-link">Προαπαιτούμενα</a>
        </li>
        <li>
          <a routerLink="/angular-framework/information" routerLinkActive="active-link">FAQ</a>
        </li>
      </ul>
    </nav>

    <router-outlet></router-outlet>
  </div>